import { useRef, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api, fmtErr } from "../lib/api";
import { KeyRound, MoonStar, ShieldCheck, Info } from "lucide-react";
import { PasswordInput } from "../components/PasswordInput";

export default function ReimpostaPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");
  const submittingRef = useRef(false);

  const submit = async (e) => {
    e.preventDefault();
    if (submittingRef.current) return;
    setError("");
    if (password !== confirm) {
      setError("Le due password non coincidono.");
      return;
    }
    submittingRef.current = true;
    setBusy(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: password, confirm_password: confirm });
      setDone(true);
    } catch (err) {
      const detail = err?.response?.data?.detail;
      if (typeof detail === "string" && detail.includes("già stato utilizzato")) {
        setError("__used__");
      } else {
        setError(fmtErr(err, "Questo link non è valido o è scaduto. Richiedi un nuovo recupero password."));
      }
    } finally {
      submittingRef.current = false;
      setBusy(false);
    }
  };

  return (
    <div className="max-w-md mx-auto px-4 py-20" data-testid="reimposta-page">
      <div className="mystic-card p-8 sm:p-10">
        <div className="text-center mb-8">
          <MoonStar className="w-8 h-8 text-amber-400 mx-auto mb-3" />
          <h1 className="font-display text-3xl text-amber-100">Reimposta password</h1>
        </div>
        {!token ? (
          <div className="text-center space-y-5" data-testid="reimposta-token-missing">
            <p className="text-purple-100/85 text-sm">Questo link non è valido: manca il codice di recupero.</p>
            <Link to="/recupera-password" data-testid="reimposta-new-request" className="inline-block text-xs text-amber-300/80 hover:text-amber-200 underline underline-offset-2 transition-colors">
              Richiedi un nuovo link
            </Link>
          </div>
        ) : done ? (
          <div className="text-center space-y-5" data-testid="reimposta-success">
            <ShieldCheck className="w-10 h-10 text-emerald-400/80 mx-auto" />
            <p className="text-purple-100/85 text-sm leading-relaxed">
              Password aggiornata correttamente. Ora puoi accedere con la nuova password.
            </p>
            <Link to="/accedi" data-testid="reimposta-login-btn" className="gold-btn inline-block px-8 py-3 text-sm">
              Vai ad Accedi
            </Link>
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-4">
            <p className="text-purple-200/70 text-sm leading-relaxed">
              Scegli la tua nuova password: minimo 6 caratteri.
            </p>
            <div className="relative">
              <KeyRound className="w-4 h-4 text-purple-300/40 absolute left-4 top-1/2 -translate-y-1/2 pointer-events-none" />
              <PasswordInput
                required
                minLength={6}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Nuova password"
                data-testid="reimposta-password-input"
                className="input-dark pl-11"
              />
            </div>
            <div className="relative">
              <KeyRound className="w-4 h-4 text-purple-300/40 absolute left-4 top-1/2 -translate-y-1/2 pointer-events-none" />
              <PasswordInput
                required
                minLength={6}
                value={confirm}
                onChange={(e) => setConfirm(e.target.value)}
                placeholder="Conferma nuova password"
                data-testid="reimposta-confirm-input"
                className="input-dark pl-11"
              />
            </div>
            {error === "__used__" && (
              <div className="rounded-xl border border-amber-500/40 bg-amber-500/5 px-4 py-3 flex items-start gap-2.5" data-testid="reimposta-used">
                <Info className="w-4 h-4 text-amber-300 mt-0.5 shrink-0" />
                <p className="text-xs text-amber-100/90 leading-relaxed">
                  Questo link è già stato utilizzato. <strong>Se hai appena completato il cambio, la tua nuova password è già attiva:</strong> puoi accedere normalmente. Altrimenti richiedi un nuovo link di recupero.
                </p>
              </div>
            )}
            {error && error !== "__used__" && <p className="text-red-400 text-sm" data-testid="reimposta-error">{error}</p>}
            {error === "__used__" && (
              <Link to="/accedi" data-testid="reimposta-used-login" className="gold-btn block text-center w-full py-3 text-sm">
                Vai ad Accedi
              </Link>
            )}
            <button type="submit" disabled={busy} data-testid="reimposta-submit-btn" className="gold-btn w-full py-3 text-sm disabled:opacity-60">
              {busy ? "Salvataggio…" : "Salva la nuova password"}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
